import { useEffect, useState } from 'react';
import { createOrGetAnonymousUser, getStoredUserId } from '../api/user';
import type { AnonymousUser } from '../api/types';

interface AnonymousUserState {
  user: AnonymousUser | null;
  userId: string | null;
  loading: boolean;
  error: string | null;
}

export function useAnonymousUser(): AnonymousUserState {
  const [state, setState] = useState<AnonymousUserState>({
    user: null,
    userId: getStoredUserId(),
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;

    createOrGetAnonymousUser()
      .then((user) => {
        if (cancelled) return;
        setState({ user, userId: user.id, loading: false, error: null });
      })
      .catch((error) => {
        if (cancelled) return;
        setState((prev) => ({
          ...prev,
          loading: false,
          error: error instanceof Error ? error.message : 'Не удалось подключиться к API',
        }));
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}

